var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"cli-s-container",attrs:{"menu":_vm.menu,"menu-style":"black","menu-active":"config","menu-name":"SUPORTE","folded":true,"no-title":"","hfull":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }